export enum LocationGroupEnum {
  GoogleLocations = 'search_result',
  SavedLocations = 'saved_location'
}
